import styled from 'styled-components';

export const WrapperShipments = styled.div`
  & > h1:first-child {
    text-align: center;
    font-size: 24px;
    margin-bottom: calc(8 * 8px);
  }
`;
